<template>
  <d2-container>
    <el-button
        class="filter-item"
        type="primary"
        size="mini"
        icon="el-icon-circle-plus"
        @click="add"
    >新增</el-button>
    <el-table
         border
         stripe
         highlight-current-row
        :data="list" >
      <el-table-column
          prop="valueName"
          label="值"
          width="400"
          align="center"
      >
        <template slot-scope="scope">
          <el-input v-model="scope.row.valueName"  size="mini" ></el-input>
        </template>
      </el-table-column>
      <el-table-column
          prop="thumbnail"
          label="缩略图"
          width="400"
          align="center"
      >
        <template slot-scope="scope">
          <upload-img v-model="scope.row.thumbnail" :show-tips="false"  :imgSize="1"></upload-img>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
      >
        <template slot-scope="scope">
          <el-button
              size="small"
              type="danger"
              @click="delCard(scope.row.idx)"
              style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <el-button @click="$router.back()">取 消</el-button>
      <el-button type="success" @click="confirm('form')">确定</el-button>
    </div>
  </d2-container>
</template>
<script>
import {
  addProduct,
  updateProduct,
  getProductInfo,
  getProductCateOption, getProductSpecValueList, updateProductSpecValue
} from '@/api/merchant/service/product'
import uploadImg from '@/components/uploadImage/index.vue'
import uploadVideo from '@/components/uploadVideo'

/**
 * 富文本工具
 */
import { quillEditor, Quill } from 'vue-quill-editor'
import { replayContent, initEditor, option, initTitle } from '@/utils/editor'
import { getClockInTplOptions } from '@/api/demo/punchInActivityTpl'
initEditor(Quill)

export default {
  name: 'editServiceProduct',
  components: {
    uploadImg,
    quillEditor,
    uploadVideo
  },
  data () {
    return {
      id: null,
      list: [],
      replyOptionLoading: false,
      editorOption: option,
      rules: {

      },
      itemRules: {
        name: [
        ]
      }
    }
  },
  created () {

  },
  methods: {
    delCard (idx) {
      let that = this
      that.list.splice(idx, 1)
    },
    add () {
      let that = this
      let idx = that.list.length
      that.list.push({
        id: null,
        valueName: '规格值' + idx,
        thumbnail: ''
      })
    },
    getList (id) {
      let that = this
      getProductSpecValueList(id)
        .then(res => {
          that.list = res
        })
    },
    confirm () {
      let that = this
      that.list.forEach((item, index) => {
        if (item.id < 100000) {
          item.id = null
        }
      })
      updateProductSpecValue(that.id, that.list).then(res => {
        that.$notify({
          title: '成功',
          message: '修改成功',
          type: 'success',
          duration: 2000
        })
        that.$router.back()
      })
    }
  },
  mounted () {
    let that = this
    that.id = that.$route.query.id

    if (that.id != null) {
      that.getList(that.id)
    }
  }
}

</script>
<style scoped>
/deep/.el-input-number {
  margin-right: 12px;
}
.footer {
  text-align: center;
  margin-top: 20px;
}

</style>
